import { render, staticRenderFns } from "./EditAndDeleteDepartment.vue?vue&type=template&id=0887e8f1&scoped=true&"
import script from "./EditAndDeleteDepartment.vue?vue&type=script&lang=js&"
export * from "./EditAndDeleteDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0887e8f1",
  null
  
)

export default component.exports